var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35156 12.0249C8.35156 11.6669 8.64215 11.3711 9.00021 11.3711C9.35826 11.3711 9.64885 11.6574 9.64885 12.0154V12.0249C9.64885 12.383 9.35826 12.6736 9.00021 12.6736C8.64215 12.6736 8.35156 12.383 8.35156 12.0249Z",
    fill: "#EB9928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76894 15.6127H15.2938C16.2858 15.5608 17.0486 14.7158 16.9976 13.7238C16.9863 13.5232 16.9431 13.3251 16.867 13.1401L10.5734 2.12524C10.0926 1.25606 8.99851 0.941248 8.12933 1.42297C7.83355 1.58557 7.58966 1.82946 7.4262 2.12524L1.13263 13.1401C0.759009 14.0603 1.20182 15.1085 2.12116 15.483C2.30797 15.5582 2.50516 15.6015 2.7058 15.6127",
    stroke: "#EB9928",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99493 9.53848V6.85742",
    stroke: "#EB9928",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/Danger.b2707006a1cdd4e4ae58263d6fb775b7.svg";
export { ForwardRef as ReactComponent };